import React__default from 'react';
import Conditional from '../../misc/Conditional/index.js';
import { loggedMenuItemsIcons } from '../icons.js';
var Notifications = function Notifications(_ref) {
  var count = _ref.count,
    onNotificationClick = _ref.onNotificationClick;
  var handleOnClick = function handleOnClick() {
    if (!!onNotificationClick) onNotificationClick();
  };
  return /* @__PURE__ */React__default.createElement("div", {
    className: "header-cp__panel-right__notification"
  }, /* @__PURE__ */React__default.createElement(Conditional, {
    condition: count > 0,
    renderIf: /* @__PURE__ */React__default.createElement("button", {
      onClick: handleOnClick,
      "aria-label": "Notifica\xE7\xF5es n\xE0o lidas"
    }, /* @__PURE__ */React__default.createElement("span", {
      className: "header-cp__panel-right__notification__icon",
      dangerouslySetInnerHTML: {
        __html: loggedMenuItemsIcons.hasNotification
      }
    })),
    renderElse: /* @__PURE__ */React__default.createElement("button", {
      onClick: handleOnClick,
      "aria-label": "Nenhuma notifica\xE7\xE3o"
    }, /* @__PURE__ */React__default.createElement("span", {
      className: "header-cp__panel-right__notification__icon",
      dangerouslySetInnerHTML: {
        __html: loggedMenuItemsIcons.notification
      }
    }))
  }));
};
export { Notifications as default };